import { BoardWithMinimalConfigAndDraftConfigIdFragment } from '@cycle-app/graphql-codegen';

export const isViewMyInbox = (board: BoardWithMinimalConfigAndDraftConfigIdFragment) => board.isBuiltIn && !!board.name.match(/inbox/i);

export const isViewAll = (board: BoardWithMinimalConfigAndDraftConfigIdFragment) => board.isBuiltIn && !!board.name.match(/all/i);
